<template>
  <controller>
    <span ref="form"></span>
    <section class="page-content">
      <transition name="fade">
        <criarFuncoes
          v-if="criar"
          :criarID="criarID"
          @close="close"
          @updateParentList="updateParentList"
        />
      </transition>
      <main>
        <box>
          <div class="table-wrap">
            <div class="table-controls">
              <a href="#" class="btn btn-primary" @click.prevent="novo">
                <fa :icon="['fas', 'plus']" />
                <span class="ml-2">Novo</span>
              </a>

              <div class="search-box">
                <input-control
                  v-model="searchTerm"
                  placeholder="Buscar por nome ou setor..."
                  name="search"
                />
              </div>
            </div>

            <table-wrapper :headers="headers">
              <template v-slot:default>
                <div
                  class="table-row"
                  v-for="(item, index) in filteredContent"
                  :key="index"
                >
                  <div class="td">{{ item.nome }}</div>
                  <div class="td">{{ item.descricao }}</div>
                  <div class="td actions">
                    <a href="#" class="btn-icon" @click.prevent="edit(item)">
                      <fa :icon="['far', 'pencil']" />
                    </a>
                  </div>
                </div>
              </template>
            </table-wrapper>
          </div>
        </box>
      </main>
    </section>
  </controller>
</template>
<script>
import axios from 'axios'
import authHeader from '@/services/auth-header'
import criarFuncoes from './Criar'

export default {
  name: "Funções",
  components: {
    criarFuncoes
  },
  data () {
    return {
      content: [],
      searchTerm: '',
      headers: ['Nome', 'Setor', 'Ações'],
      criar: false,
      criarID: null
    }
  },
  computed: {
    filteredContent () {
      if (!this.searchTerm.trim()) return this.content
      const term = this.searchTerm.trim().toLowerCase()
      return this.content.filter(item =>
        (item.nome || '').toLowerCase().includes(term) ||
        (item.descricao || '').toLowerCase().includes(term)
      )
    }
  },
  mounted () {
    this.listFuncoes()
  },
  methods: {
    listFuncoes () {
      window.spinner.emit('open')
      axios.get(process.env.VUE_APP_API_URL + 'funcoes',{ headers: authHeader() })
        .then(response => {
          this.content = response.data
        })
        .catch(error => {
          console.error("error:", error)
        })
        .finally(() => {
          window.spinner.emit('close')
        })
    },
    close () {
      this.criar = false
      this.criarID = null
      this.listFuncoes()
    },
    delete (id) {
      window.spinner.emit('open')
      axios.delete(process.env.VUE_APP_API_URL + 'funcao/' + id, { headers: authHeader() })
        .then(() => {
          window.toaster.emit('open', {
            style: "success",
            message: "Função removida com sucesso."
          })
          this.listFuncoes()
        })
        .catch(error => {
          const msg = error.response?.data?.message || "Erro ao remover função. Ela pode estar em uso."
          window.toaster.emit('open', {
            style: "error",
            message: msg
          })
        })
        .finally(() => {
          window.spinner.emit('close')
        })
    },
    novo () {
      this.criar = true
      this.scrollUp()
    },
    edit (item) {
      this.criar = true
      this.scrollUp()
      setTimeout(() => {
        this.criarID = item
      }, 100)
    },
    scrollUp () {
      this.$refs.form.scrollIntoView({ behavior: "smooth", block: 'center' })
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  padding: $hmg_mid;
}
.table-wrap {
  padding: $hmg $hmg_small $mg_extra;
}
.table-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: $hmg;
  gap: $hmg;
}
.search-box {
  width: 300px;
}
.table-row {
  display: flex;
  align-items: center;
  padding: $hmg_small $hmg;
  border-bottom: $border-component;

  .td {
    flex: 1;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: $hmg_small;
    flex: none;

    .btn-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      padding: 0.5rem;
      color: $color-text;
      cursor: pointer;
      transition: color 0.2s;

      &.danger {
        color: $color-apollo;

        &:hover {
          color: darken($color-apollo, 10%);
        }
      }
      
      &:hover {
        color: $color-primary;
      }
    }
  }
}
</style>  